import { render } from "./PerfilFamiliar.vue?vue&type=template&id=9127e2bc"
import script from "./PerfilFamiliar.vue?vue&type=script&lang=ts"
export * from "./PerfilFamiliar.vue?vue&type=script&lang=ts"
script.render = render

export default script